import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { AlertFilterCards } from '@components/StoreMonitoring/StoreDashboard/AlertFilterCards'
import { Horizontal, useDeviceType, Vertical } from '@gravitate-js/excalibrr'
import { useLocalStorage } from '@gravitate-js/the-armory'
import { useState } from 'react'

import { useSiteMonitoringContext } from '../SiteMonitoringContext'
import { StoreMonitoringGrid } from './Grid/Grid'
import { SiteMap } from './Map'
import { Dashboard as SiteMonitoringMobile } from './mobile/Dashboard'

export function MapAndGrid(setHighlightedStore, highlightedStore) {
  const [showingMap, setShowingMap] = useState(true)
  const { value: rundownToggled, setValue: setToggle } = useLocalStorage('show_projected_drops', true)
  const { data } = useSiteMonitoringContext()
  const { scopes } = useSecurityContext()
  const canCreateOrder = scopes.scopes.includes('o.w')
  const { isMobile } = useDeviceType()

  const alertCounts = data?.spark_graphs
  if (isMobile) return <SiteMonitoringMobile rundownToggled={rundownToggled} setToggle={setToggle} data={data} />
  return (
    <div className='vertical-flex flex-1' style={{ overflow: 'hidden' }}>
      <Horizontal
        style={{
          height: showingMap ? '50%' : 0,
          minHeight: showingMap ? '300px' : 0,
          transition: '1s ease',
          display: 'flex',
        }}
      >
        <AlertFilterCards data={alertCounts} />
        <Vertical flex={3}>
          <RegionMap showingMap={showingMap} highlightedStore={highlightedStore} rundownToggled={rundownToggled} />
        </Vertical>
      </Horizontal>
      <div style={{ height: showingMap ? '60%' : '100%', transition: '1s ease' }}>
        <StoreMonitoringGrid
          canCreateOrder={canCreateOrder}
          setShowingMap={setShowingMap}
          showingMap={showingMap}
          onStoreHover={setHighlightedStore}
          rundownToggled={rundownToggled}
          setToggle={setToggle}
        />
      </div>
    </div>
  )
}

function RegionMap({ highlightedStore, showingMap, rundownToggled }) {
  const { showingModal, data, filteredStores } = useSiteMonitoringContext()
  if (!showingMap || showingModal) return null
  const stores = filteredStores?.length > 500 ? filteredStores?.filter((s) => s.flags.length !== 0) : filteredStores
  return (
    <SiteMap
      mapCenter={data?.map_center}
      zoom={data?.map_zoom}
      stores={stores}
      highlightedStore={highlightedStore}
      rundownToggled={rundownToggled}
    />
  )
}
